import React, { Component } from 'react';
import './text.css';

export default class Text extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <p className="rdp-react-template-component-text">
        {this.props.content}
      </p>
    );
  }
}
